<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

type Size = 'sm' | 'md' | 'lg'

const props = withDefaults(
  defineProps<{
    to?: RouteLocationRaw
    href?: string
    type?: 'button' | 'submit' | 'reset'
    size?: Size
    disabled?: boolean
    ariaLabel: string
  }>(),
  {
    type: 'button',
    size: 'md',
    disabled: false,
  },
)

const sizeClass = computed(() => `app-icon-btn--${props.size}`)

function onClick(event: MouseEvent) {
  if (!props.disabled) return
  event.preventDefault()
  event.stopPropagation()
}
</script>

<template>
  <NuxtLink
    v-if="to"
    :to="to"
    class="app-icon-btn"
    :class="sizeClass"
    :aria-label="ariaLabel"
    :aria-disabled="disabled ? 'true' : undefined"
    :tabindex="disabled ? -1 : undefined"
    @click="onClick"
  >
    <slot />
  </NuxtLink>

  <a
    v-else-if="href"
    :href="href"
    class="app-icon-btn"
    :class="sizeClass"
    :aria-label="ariaLabel"
    :aria-disabled="disabled ? 'true' : undefined"
    :tabindex="disabled ? -1 : undefined"
    @click="onClick"
  >
    <slot />
  </a>

  <button
    v-else
    :type="type"
    class="app-icon-btn"
    :class="sizeClass"
    :disabled="disabled"
    :aria-label="ariaLabel"
  >
    <slot />
  </button>
</template>
